'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function (FieldDisplayStates) {
  FieldDisplayStates["Hidden"] = "hidden";
  FieldDisplayStates["Disabled"] = "disabled";
  FieldDisplayStates["Visible"] = "visible";
})(exports.FieldDisplayStates || (exports.FieldDisplayStates = {}));
//# sourceMappingURL=index.js.map
